<template>
  <el-dialog :visible="visible" :title="title" width="800px" @close="close">
    <el-alert v-if="grayShop" type="warning" show-icon style="margin-bottom: 10px;"> 
      <div style="color: #333">
        根据抖音店铺类目升级灰度状态，可切换店铺获取对应的发布商品规则，同灰度状态店铺可使用同一套资料发布商品
      </div>
    </el-alert>
    <el-row>
      <el-col v-for="s in data" :key="s.userId" :span="6">
        <el-radio v-model="shopId" :label="s.id || s.shopId">
          {{ s.title || s.shopName }} 
          <span v-if="s.shopGray" style="color: #f00;">(灰度)</span>
        </el-radio>
      </el-col>
    </el-row>
    <template slot="footer">
      <el-button @click="close">取消</el-button>
      <el-button @click="ok" type="primary">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'shop-dialog',
  props: {
    title: {
      type: String,
      default: '选择店铺',
    },
    visible: Boolean,
    grayShop: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      shopId: '',
    };
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
      this.shopId = '';
    },
    ok() {
      if (!this.shopId) return this.$message.warning('请选择一个店铺');
      this.$emit('ok', this.shopId);
      this.close();
    },
  },
};
</script>
